// frontend/src/components/players/PDFViewer.js
import React from 'react';
import { useSecureMedia } from '../../services/mediaService';
import { Loader, FileText, RefreshCw } from 'lucide-react';

const PDFViewer = ({ mediaId, fileUrl, title }) => {
  const { mediaUrl, isLoading: urlLoading, error: urlError, refetch: refetchMediaUrl } =
    useSecureMedia(mediaId);

  const directPdf = fileUrl || mediaUrl;

  // ساخت URL پروکسی
  const proxyUrl = directPdf?.startsWith('https://s3.afra.kubit.cloud/')
    ? `https://farzaneh.app/api/proxy/media/?url=${encodeURIComponent(directPdf)}`
    : directPdf;

  if (urlError) {
    return (
      <div className="p-8 text-center text-red-400 bg-white h-screen flex flex-col items-center justify-center rtl">
        <FileText size={48} className="mb-4" />
        <p className="font-bold mb-4">{urlError}</p>
        <button onClick={() => refetchMediaUrl?.()} className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition">
          <RefreshCw size={18} /> تلاش مجدد
        </button>
      </div>
    );
  }

  if (urlLoading || !proxyUrl) {
    return (
      <div className="p-8 text-center text-gray-600 bg-white h-screen flex flex-col items-center justify-center rtl">
        <Loader size={48} className="animate-spin mb-4" />
        <p>در حال بارگذاری...</p>
      </div>
    );
  }

  return (
    <iframe
      src={proxyUrl}
      title={title || 'سند PDF'}
      className="w-full h-screen border-0"
    />
  );
};

export default PDFViewer;